

module.exports = __webpack_require__.stylable.create(
    "Text2106135923",
    {"classes":{"root":"Text2106135923__root","header-xs-responsive-mobile-mixin":"Text2106135923__header-xs-responsive-mobile-mixin","header-s-secondary-mobile-mixin":"Text2106135923__header-s-secondary-mobile-mixin","header-s-mobile-mixin":"Text2106135923__header-s-mobile-mixin","header-m-mobile-mixin":"Text2106135923__header-m-mobile-mixin","header-l-mobile-mixin":"Text2106135923__header-l-mobile-mixin","p2-m-mobile-mixin":"Text2106135923__p2-m-mobile-mixin"},"vars":{},"stVars":{"titlesColor":"\"'color(--title-color)'\"","textsColor":"'\"color(--text-color)\"'","textsColorOpacity60":"'\"opacity(color(--text-color), 0.6)\"'","textsColorOpacity80":"'\"opacity(color(--text-color), 0.8)\"'","titlesFont":"'\"font(--title-font)\"'","textsFont":"'\"font(--text-font)\"'"},"keyframes":{}},
    "",
    14,
    "Text2106135923",
    null
);
